import * as React from 'react';
import { SVGProps } from 'react';

const IconIpadStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2Zm7 1H2v6h7V3Z"
    />
  </svg>
);
export default IconIpadStrokedSizeXs;
